
import { Investment } from "@/types/investment";
import { transformInvestmentWithYield } from "@/utils/investmentCalculations";
import { determineCreditRating } from "@/utils/creditRatingUtils";
import { determinePropertyAddress, calculatePropertyValue } from "@/utils/propertyAddressUtils";

export const transformDatabaseItemToInvestment = (item: any): Investment => {
  console.log(`Processing item ${item.id}:`, {
    id: item.id,
    title: item.title,
    property_address: item.property_address,
    property_value: item.property_value,
    asking_price: item.asking_price,
    investor_yield: item.investor_yield,
    thumbnail_image: item.thumbnail_image,
    raw_item: item
  });

  const propertyAddress = determinePropertyAddress(item.property_address, item.title);
  const creditRating = determineCreditRating(item.buyer_credit_score_summary);
  const propertyValue = calculatePropertyValue(
    item.property_value, 
    item.remaining_balance, 
    item.investment_to_value
  );

  // Use the proper yield calculation function
  const baseInvestment = {
    asking_price: item.asking_price,
    monthly_payment: item.monthly_payment,
    term_remaining: item.term_remaining,
    balloon_payment_amount: item.balloon_payment_amount
  };

  const investmentWithYield = transformInvestmentWithYield(baseInvestment);

  const transformed: Investment = {
    id: item.id,
    type: item.title?.includes('Land Contract') ? 'Land Contract' : 'Private Mortgage',
    location: item.property_address || item.title?.split(' - ')[1] || 'Location TBD',
    propertyAddress: propertyAddress,
    currentBalance: item.remaining_balance || 0,
    monthlyPayment: item.original_monthly_payment || item.monthly_payment || 0,
    interestRate: item.original_interest_rate || parseFloat(item.investor_yield?.replace(/[^\d.]/g, '') || '0'),
    remainingTerms: parseInt(item.term_remaining?.replace(/[^\d]/g, '') || '0'),
    yield: parseFloat(investmentWithYield.investor_yield?.replace(/[^\d.]/g, '') || '0'),
    status: item.status === 'Available' ? 'Open for Bidding' : item.status,
    riskLevel: 'Medium',
    ltv: parseInt(item.investment_to_value?.replace(/[^\d]/g, '') || '0'),
    propertyValue: propertyValue,
    minimumBid: Math.round((item.asking_price || item.remaining_balance || 0) * 0.95),
    balloonPaymentAmount: item.balloon_payment_amount,
    balloonPaymentDueDate: item.balloon_payment_due_date,
    hasBalloonPayment: item.has_balloon_payment || false,
    salesDate: item.sales_date || undefined,
    originalSalesPrice: item.original_sales_price || undefined,
    originalDownPayment: item.original_down_payment || undefined,
    originalTerm: item.original_term || undefined,
    askingPrice: item.asking_price,
    paymentHistory: item.buyer_payment_history_summary || undefined,
    creditRating: creditRating,
    propertyType: item.collateral_details ? item.collateral_details.split(',')[0]?.trim() : 'Single Family',
    propertyDescription: item.collateral_details || undefined,
    realtorLink: item.realtor_com_link || undefined,
    zillowLink: item.zillow_com_link || undefined,
    thumbnail_image: item.thumbnail_image || undefined,
    
    // Include admin fields for compatibility
    title: item.title,
    description: item.description,
    collateral_details: item.collateral_details,
    investor_yield: item.investor_yield,
    investment_to_value: item.investment_to_value,
    buyer_payment_history_summary: item.buyer_payment_history_summary,
    buyer_credit_score_summary: item.buyer_credit_score_summary,
    term_remaining: item.term_remaining,
    realtor_com_link: item.realtor_com_link,
    zillow_com_link: item.zillow_com_link,
    county_assessor_link: item.county_assessor_link,
    documents_link: item.documents_link,
    customer_id: item.customer_id
  };

  console.log(`Transformed item ${item.id}:`, transformed);
  return transformed;
};
